module.exports = __webpack_public_path__ + "img/xc.065dc0fc.png";